import { type OperationDefinitionNode, Kind } from 'graphql'
import type { ApolloLink } from '@apollo/client'

export const getOperationName = ({ operationName, query }: ApolloLink.Operation): string => {
  if (!operationName) {
    return ''
  }

  const { operation = 'unknown' } =
    query.definitions.find((definition): definition is OperationDefinitionNode =>
      definition.kind === Kind.OPERATION_DEFINITION ? definition.name?.value === operationName : false,
    ) ?? {}

  return `${operation}:${operationName}`
}
